<template>
  <crud-editor
    ref="editor"
    :definition="definition"
    :is-edit="false"
    :auto-generated-id="false"
    :save="saveData"
    :return-to="returnTo"
    :item-type="entity"
    :get-layout="layout"
  />
</template>

<script>
import CrudEditor from '@/components/crud/Editor';
import formMixin from './form-mixin';
import { getLayoutDefinition } from './form.js';

export default {
  components: {
    CrudEditor
  },
  mixins: [formMixin],
  data() {
    return {
      layout: getLayoutDefinition
    };
  },
  methods: {
    saveData(form) {
      const item = this.createItemFromFormData(this, form);
      return this.$store.dispatch(this.entityStore + '/persistItem', item);
    }
  }
};
</script>
